module.exports = __webpack_public_path__ + "static/media/duo_guru_desc2.9312d04e.jpeg";